import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiVideo, FiExternalLink } = FiIcons;

const VideoShowcase = () => {
  const videos = [
    {
      id: 'promo',
      title: 'Marketing Promotional Video',
      directLink: 'https://iframe.mediadelivery.net/play/476397/9e0830d6-2447-4d9e-9fd0-4e7f16e8d724',
      description: 'Professional promotional content featuring sponsor branding'
    },
    {
      id: 'closing',
      title: 'Summit Close & Thank You Video',
      directLink: 'https://iframe.mediadelivery.net/play/476397/5c7833b0-9df3-4052-a13a-66170c85c31d',
      description: 'Closing remarks with sponsor acknowledgments'
    }
  ];

  return (
    <motion.div
      className="glass-effect rounded-2xl p-8"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="text-center mb-8">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <SafeIcon icon={FiVideo} className="text-red-400 mr-3" />
          Premium Video Content with Sponsor Branding
        </motion.h2>
        <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-pink-500 mx-auto rounded-full" />
      </div>

      <motion.div
        className="bg-gradient-to-r from-red-500/20 to-purple-500/20 rounded-xl p-6 border border-red-500/30 text-center"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3 }}
      >
        <div className="flex items-center justify-center mb-4">
          <SafeIcon icon={FiVideo} className="text-red-400 text-2xl mr-3" />
          <h3 className="text-xl font-bold text-white">Professional Video Production</h3>
        </div>
        <p className="text-white/90 text-lg leading-relaxed mb-6">
          These professional-quality videos continue to showcase your brand long after the event. Two key examples are shown below - our promotional marketing video and summit closing remarks with sponsor recognition.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          {videos.map((video, index) => (
            <motion.a
              key={video.id}
              href={video.directLink}
              target="_blank"
              rel="noopener noreferrer"
              className="glass-effect rounded-lg p-6 hover:bg-white/10 transition-all duration-300 group border border-white/20 hover:border-white/40"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 + index * 0.1 }}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="text-left">
                  <div className="text-white font-semibold text-lg mb-1">{video.title}</div>
                  <div className="text-white/70 text-sm">{video.description}</div>
                </div>
                <SafeIcon 
                  icon={FiExternalLink} 
                  className="text-proactuary-blue-400 group-hover:text-proactuary-blue-300 transition-colors text-xl flex-shrink-0 ml-3" 
                />
              </div>
              <div className="text-proactuary-blue-300 text-sm font-medium">
                Click to watch video →
              </div>
            </motion.a>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default VideoShowcase;